<div class="form-container" *ngIf="totalItems === 0 || totalItems > 0">
  <div *ngIf="!isLoading">
    <div class="col-12 list-header">
      <!-- <div class="col-lg-6 results-heading"> -->
      <div class="list-header-title">
        <div class="title">{{ 'ORDERS.LIST.TITLE' | translate }}</div>
        <div class="subtitle">{{ 'ORDERS.LIST.SUBTITLE' | translate }}</div>
      </div>
      <div class="list-header-description">
        <div class="count">
          <span *ngIf="totalItems > 1 || totalItems === 0">{{ 'ORDERS.LIST.COUNT' | translate: { count: totalItems } }}</span>
          <span *ngIf="totalItems === 1">{{ 'ORDERS.LIST.COUNT_1' | translate }}</span>
        </div>
        <div class="count-postscript">{{ 'ORDERS.LIST.COUNT-POSTSCRIPT' | translate }}</div>
      </div>
      <div class="list-header-actions">
        <ng-container *ngIf="totalItems > 0">
          <eps-button
            [busy]="isDownloading"
            [disabled]="isDownloading"
            *ngIf="authorization.ORDER.LIST_ORDERS_AS_DOCUMENT"
            (buttonClick)="downloadFile.emit('XLS')"
            label="ORDERS.LIST.EXCEL"
          ></eps-button>
          <eps-button
            [busy]="isDownloading"
            *ngIf="allCorrectionsOrderIds.length > 0"
            (buttonClick)="toggleShowAllCorrections()"
            [label]="'SHARED.LABELS.' + (showAllCorrections ? 'COLLAPSE_ALL' : 'SHOW_ALL')"
          ></eps-button>
        </ng-container>
      </div>
    </div>

    <div class="row col-12 pagination" *ngIf="!isLoading && totalItems > 0">
      <app-pager [itemsPerPage]="filter.pageSize" (pageChange)="onPageChange($event)" (itemsPerPageChange)="itemsPerPageChange.emit($event)"></app-pager>
    </div>

    <div class="col-12 row bottom-line bold show-from-sm sorters" *ngIf="!smallScreen && totalItems > 0">
      <span class="status"></span>
      <span class="sorter col-md" sortable-header="orderDate" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.ORDER_DATE' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="etmOrderNumber" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.NUMBER' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="salesOrderNumber" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="fromId" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.FROM' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="toId" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.TO' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="requestedUnloadingDate" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.REQUESTED_DATE' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="confirmedUnloadingDate" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.CONFIRMED_DATE' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="shippingCondition" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.TRANSPORT' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="globalType" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.GLOBAL_TYPE' | translate
        }}</span>
      <span class="menu_col"></span>
    </div>

    <ng-template #ccrLines let-order>
      <div class="ccr-line-items row">
        <div class="grid-container col-12 col-md-8">
          <div class="heading">{{ 'FLOWS.LIST.LABELS.TYPE' | translate }}</div>
          <div class="heading">{{ 'FLOWS.LIST.LABELS.ORIGINAL' | translate }}</div>
          <div class="heading">{{ 'FLOWS.LIST.LABELS.DEFINITIVE' | translate }}</div>
          <div class="heading">{{ 'FLOWS.LIST.LABELS.DIFFERENCE' | translate }}</div>
          <div class="heading link" *ngIf="order.ccr.ccrLineItems.length === 0"></div>
          <div class="heading link" (click)="preventRouting($event); toggleCollapsed(order.etmOrderNumber, order.salesOrderNumber)" *ngIf="order.ccr.ccrLineItems.length > 1">
            <span
              *ngIf="!isCollapsed(order.etmOrderNumber, order.salesOrderNumber)">{{'FLOWS.LIST.LABELS.COLLAPSE_COUNT' | translate: { count: order.ccr.ccrLineItems.length } }}</span>
            <span *ngIf="isCollapsed(order.etmOrderNumber, order.salesOrderNumber)">{{'FLOWS.LIST.LABELS.SHOW_COUNT' | translate: { count: order.ccr.ccrLineItems.length } }}</span>
          </div>
          <ng-container class="row item" *ngFor="let ccrLine of order.ccr.ccrLineItems | oneOrAllFilter: isCollapsed(order.etmOrderNumber, order.salesOrderNumber)">
            <div>
              <eps-select
                [options]="definitions.packing.type"
                labelPosition="none"
                [ngModel]="ccrLine.packingId"
                [readonly]="true"
                [showErrors]="false"
                *ngIf="ccrLine.packingId"
                autoSelect
              ></eps-select>
              <eps-select
                [options]="definitions.pallet.type"
                labelPosition="none"
                [ngModel]="ccrLine.palletId"
                [readonly]="true"
                [showErrors]="false"
                *ngIf="!ccrLine.packingId && ccrLine.palletId"
                autoSelect
              ></eps-select>
            </div>
            <div>
              {{ getLoadedQuantity(ccrLine) }}
            </div>
            <div>
              {{ getUnloadedQuantity(ccrLine) }}
            </div>
            <div>
              {{ getDifference(ccrLine) }}
            </div>
            <div></div>
          </ng-container>
        </div>
        <div class="col-12 col-md-4 deviation_buttons">
          <ng-container *ngIf="showCcrButtons(order)">
            <eps-button
              class="default accept"
              buttonIcon="check"
              size="small" (buttonClick)="acceptDeviationClicked($event, order)"
              [busy]="order.ccr.UI.submittingAccept"
              [disabled]="order.ccr.UI.submittingReject"
              *ngIf="restrictions.useCcrValidation && authorization.ORDER.ACCEPT"
              label="ORDERS.LIST.BUTTONS.ACCEPT"
            ></eps-button>
            <eps-button
              class="default reject"
              buttonIcon="times"
              size="small"
              (buttonClick)="rejectDeviationClicked($event, order)"
              [busy]="order.ccr.UI.submittingReject"
              [disabled]="order.ccr.UI.submittingAccept"
              *ngIf="restrictions.useCcrValidation && authorization.ORDER.CANCEL"
              label="ORDERS.LIST.BUTTONS.REJECT"
            ></eps-button>
          </ng-container>
          <ng-container *ngIf="order.ccr.accepted">
            <div class="accept bold">
              <eps-icon icon="check"></eps-icon>
              {{ 'ORDERS.LIST.LABELS.ACCEPTED' | translate }}
            </div>
          </ng-container>
          <ng-container *ngIf="order.ccr.declined">
            <div class="reject bold">
              <eps-icon icon="times"></eps-icon>
              {{ 'ORDERS.LIST.LABELS.REJECTED' | translate }}
            </div>
          </ng-container>
        </div>
      </div>

    </ng-template>

    <div
      *ngFor="let order of orders | paginate: { itemsPerPage: filter.pageSize, currentPage: filter.pageNr, totalItems: totalItems }"
      class="row col-12 striped cell soft-line order"
      [ngClass]="{ cancelled: order.status?.id === '03', canOpen: authorization.ORDER.GET, card: smallScreen }"
    >

      <mat-menu #menuOrderLine="matMenu" [overlapTrigger]="false">
        <button mat-menu-item type="button" (click)="editCCR.emit(order)" *ngIf="canEditCcr(order)">
          <span>{{'ORDERS.FILTER.LABELS.EDIT_CCR' | translate}}</span>
        </button>
        <button mat-menu-item type="button" (click)="createCCR.emit(order)" *ngIf="canCreateCcr(order)">
          <span>{{ 'ORDERS.FILTER.LABELS.CREATE_CCR' | translate }}</span>
        </button>
        <button mat-menu-item type="button" (click)="copyOrder.emit(order)" *ngIf="canCopyOrder(order)">
          <span>{{ 'ORDERS.LIST.BUTTONS.COPY' | translate }}</span>
        </button>
        <button mat-menu-item type="button" (click)="asTemplate.emit(order)" *ngIf="canCreateTemplate(order)">
          <span>{{ 'ORDERS.LIST.BUTTONS.AS_TEMPLATE' | translate }}</span>
        </button>
        <button mat-menu-item type="button" (click)="downloadCCRDocument.emit(order.ccr.ccrNumber)" *ngIf="canDownloadCcrDocument(order)">
          <span>{{ 'ORDERS.LIST.BUTTONS.DOWNLOAD_DOCUMENT' | translate }}</span>
        </button>
      </mat-menu>


      <ng-container *ngIf="smallScreen; else bigScreen">
        <app-item-card
          [clickable]="true"
          [menu]="menuOrderLine"
          (openItemClicked)="orderClicked(order)"
        >
          <div class="item-card-header" header>
            <div class="status">
              <app-status layout="BULLET" mode="order" [type]="order.status" [size]="1" [height]="40" position="right"></app-status>
            </div>
            <div class="etmOrderNumber">{{order.etmOrderNumber}}</div>
            <div class="orderDate">{{ order.orderDate | date: dateFormat }}</div>
          </div>
          <div class="item-card-body" body>
            <div class="fromto">
              <div class="from">{{order.from.name}}</div>
              <app-arrow [width]="50"></app-arrow>
              <div class="from">{{order.to.name}}</div>
            </div>
            <div class="body-content">
              <eps-label-body label="ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER" labelWidth="50%" [readonly]="true">
                <div class="salesOrderNumber-container">
                  <div class="salesOrderNumbers">
                    <span (click)="correctionsClicked(order, $event)">{{order.salesOrderNumber}}</span>
                    <span class="corrections" *ngIf="correctionsVisible(order)" (click)="correctionsClicked(order, $event)">
                      <div class="salesOrderNumber" @easeInOut *ngFor="let nr of order.corrections.salesOrderNumbers">{{ nr }}</div>
                    </span>
                  </div>
                  <div class="corrections-toggle" *ngIf="order.corrections.showCorrections" (click)="correctionsToggleClicked(order, $event)">
                    <i class="fa fa-caret-down" *ngIf="!correctionsVisible(order)"></i>
                    <i class="fa fa-caret-up" *ngIf="correctionsVisible(order)"></i>
                  </div>
                </div>
              </eps-label-body>
              <eps-date-input [ngModel]="order.requestedUnloadingDate" [readonly]="true" label="ORDERS.LIST.LABELS.REQUESTED_DATE" labelWidth="50%" [showErrors]="false"
                              *ngIf="order.requestedUnloadingDate"></eps-date-input>
              <eps-date-input [ngModel]="order.confirmedUnloadingDate" [readonly]="true" label="ORDERS.LIST.LABELS.CONFIRMED_DATE" labelWidth="50%" [showErrors]="false"
                              *ngIf="order.confirmedUnloadingDate"></eps-date-input>
              <eps-text-input [ngModel]="order.shippingCondition.name" [readonly]="true" label="ORDERS.LIST.LABELS.TRANSPORT" labelWidth="50%" [showErrors]="false"
                              *ngIf="order.shippingCondition"></eps-text-input>
              <eps-text-input [ngModel]="order.globalType.name" [readonly]="true" label="ORDERS.LIST.LABELS.GLOBAL_TYPE" labelWidth="50%" [showErrors]="false"
                              *ngIf="order.globalType"></eps-text-input>
              <eps-text-input [ngModel]="order.ccr.ccrLineItems.length" [readonly]="true" label="CCR.DETAILS.CCR_LINES" labelWidth="50%" [showErrors]="false"
                              *ngIf="order.ccr.ccrLineItems.length > 0"></eps-text-input>
            </div>
            <ng-container *ngIf="order.ccr.ccrLineItems.length > 0">
              <ng-container *ngTemplateOutlet="ccrLines; context: {$implicit: order}"></ng-container>
            </ng-container>
          </div>
        </app-item-card>
      </ng-container>

      <ng-template #bigScreen>
        <div class="col-11 col-md-12 order_line" (click)="orderClicked(order)">
          <div class="app_status">
            <app-status layout="BULLET" mode="order" [type]="order.status" [size]="1" [height]="40" position="right"></app-status>
          </div>
          <div class="content">
            <div class="row order_data">
              <div class="order_data-data">
                <div class="col-md col-12">{{ order.orderDate | date: dateFormat }}</div>
                <div class="col-md col-12 sales-number cell-row">{{ order.etmOrderNumber }}</div>
                <div class="col-md col-12 sales-number cell-row salesOrderNumber">
                  <div class="value">
                    {{ order.salesOrderNumber }}
                    <span class="corrections-toggle" *ngIf="order.corrections.showCorrections" (click)="correctionsToggleClicked(order, $event)">
                    <i class="fa fa-caret-down" *ngIf="!correctionsVisible(order)"></i>
                    <i class="fa fa-caret-up" *ngIf="correctionsVisible(order)"></i>
                  </span>
                  </div>
                  <span class="corrections" *ngIf="correctionsVisible(order)" (click)="correctionsClicked(order, $event)">
                  <div class="salesOrderNumber" @easeInOut *ngFor="let nr of order.corrections.salesOrderNumbers">{{ nr }}</div>
                </span>
                </div>
                <div class="col-md col-12 row cell-row">
                  <div class="row col-xs start-xs">
                    <div class="col-xs">
                      {{ order.from.name }}
                    </div>
                  </div>
                </div>

                <!-- copy -->
                <div class="col-md col-12 row cell-row">
                  <div class="row col-xs start-xs">
                    <div class="col-xs">
                      {{ order.to.name }}
                    </div>
                  </div>
                </div>

                <div class="col-md col-12">
                  {{ order.requestedUnloadingDate | date: dateFormat }}
                </div>

                <div class="col-md col-12 row cell-row">
                  <div class="row col-xs start-xs">
                    <div class="col-xs">
                      {{ order.confirmedUnloadingDate | date: dateFormat }}
                    </div>
                  </div>
                </div>

                <div class="col-md col-12 row cell-row">
                  <div class="row col-xs start-xs">
                    <div class="col-xs">
                      {{ order.shippingCondition?.name }}
                    </div>
                  </div>
                </div>

                <div class="col-md col-12 row cell-row">
                  <div class="row col-xs start-xs">
                    <div class="col-xs">
                      {{ order.globalType?.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="order_data-menu more_ellipsis">
                <div *ngIf="canShowMenu(order)">
                  <div class="more_ellipsis" [matMenuTriggerFor]="menuOrderLine" (click)="openMenu($event)">
                    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="order.ccr.ccrLineItems.length > 0">
              <ng-container *ngTemplateOutlet="ccrLines; context: {$implicit: order}"></ng-container>
            </ng-container>

          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="loading_spinner" *ngIf="isLoading">
    <i class="fa fa-spinner fa-pulse fa-fw"></i>
  </div>

  <div class="row col-12 pagination" *ngIf="!isLoading && totalItems > 0">
    <app-pager [itemsPerPage]="filter.pageSize" (pageChange)="onPageChange($event)" (itemsPerPageChange)="itemsPerPageChange.emit($event)"></app-pager>
  </div>
</div>
